module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 pv3 ph4 pl-box-shadow"
  }, [_c('div', {
    staticClass: "row col-xs center-xs middle-xs title"
  }, [_c('span', [_vm._v("Number of RoundTables")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.number_rts_description),
      expression: "number_rts_description"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "number-of-rts-graph-data"
    }
  }), _vm._v(" "), (_vm.show_modal) ? _c('pl-dialog', {
    attrs: {
      "maxWidth": '800px',
      "maxHeight": '80%',
      "padding": '2em'
    },
    on: {
      "close": function($event) {
        _vm.show_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "header-title mb2 center-xs"
  }, [_vm._v("\n      " + _vm._s(_vm.header_modal) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0"
    }
  }, [_c('pl-button', {
    staticStyle: {
      "min-width": "0",
      "font-size": "20px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_modal = false
      }
    }
  }, [_c('strong', [_vm._v("X")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "center-xs mb3 sub-header"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.sub_header_modal) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb3 b"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_vm._v("Students Invited")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_vm._v("Teacher")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_vm._v("Course / Section")])]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, _vm._l((_vm.roundtables_to_show), function(rt, index) {
    return _c('div', {
      key: index,
      staticClass: "row middle-xs row-style"
    }, [_c('div', {
      staticClass: "col-xs-4 truncate-text",
      class: rt.course_school_id === _vm.school_id ? 'linkable' : '',
      on: {
        "click": function($event) {
          return _vm.goToRoundtable(_vm.header_modal, rt)
        }
      }
    }, [_vm._v("\n          " + _vm._s(rt.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 truncate-text p4"
    }, [_vm._v("\n          " + _vm._s(rt.invited_users) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 truncate-text"
    }, [_vm._v("\n          " + _vm._s(rt.teacher_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 truncate-text",
      class: rt.course_school_id === _vm.school_id ? 'linkable' : '',
      on: {
        "click": function($event) {
          return _vm.goToCourse(rt)
        }
      }
    }, [_vm._v("\n          " + _vm._s(rt.course_title) + "\n        ")])])
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b2542352!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/standardGraphs/numberOfRtsGraph.vue
// module id = 2154
// module chunks = 61